// import { StyleSheet } from 'react-native';
import StyleSheet from 'react-native-media-query';
import { DefaultTheme } from 'react-native-paper';

export const theme = {
  ...DefaultTheme,
  roundness: 2,
  colors: {
    ...DefaultTheme.colors,
    primary: '#3498db',
    secondary: '#85C4ED',
    disabled: '#f0f0f0f0',
    accent: '#f1c40f',
    warning: '#ffa726',
    error: '#f44336',
    info: '#29b6f6',
    success: '#66bb6a',
    text: '#000',
  },
};

const { ids, styles } = StyleSheet.create({
  containerFlex: {
    backgroundColor: '#fff',
    flex: 1,
  },
  container: {
    backgroundColor: '#fff',
  },
  highZIndex: {
    zIndex: 1000,
  },
  mainTitle: {
    textAlign: 'center',
    marginTop: 30,
    fontSize: 30,
    fontWeight: 'bold',
  },
  subTitle: {
    textAlign: 'center',
    fontSize: 15,
    marginTop: 30,
    color: 'grey',
  },
  middle: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  left: {
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  right: {
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexDirection: 'row',
  },
  error: {
    color: '#ff0000',
  },
  text2: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingTop: 5,
  },
  signupText: {
    fontWeight: 'bold',
    alignSelf: 'center',
  },
  forgotPassword: {
    fontSize: 10,
    fontStyle: 'italic',
  },
  field: {
    marginTop: 30,
  },
  whiteBackground: {
    backgroundColor: 'white',
  },
  input: {
    marginTop: 10,
    marginRight: 5,
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 15,
    marginRight: 15,
  },
  textInput: {
    width: '90%',
  },
  buttonStyle: {
    marginTop: 30,
    marginLeft: 15,
    marginRight: 15,
  },
  buttonStyleX: {
    marginTop: 12,
    marginLeft: 15,
    marginRight: 15,
  },
  buttonDesign: {
    backgroundColor: 'rgba(28, 28, 30, 0.68)',
  },
  lineStyle: {
    flexDirection: 'row',
    marginTop: 30,
    marginLeft: 15,
    marginRight: 15,
    alignItems: 'center',
  },
  imageStyle: {
    width: 80,
    height: 80,
    marginLeft: 20,
  },
  boxStyle: {
    flexDirection: 'row',
    marginTop: 30,
    marginLeft: 15,
    marginRight: 15,
    justifyContent: 'space-around',
  },
  logoStyle: {
    '@media (max-width: 800px)': {
      width: '50%',
      alignSelf: 'center',
    },
    padding: 20,
  },
  responsiveImage: {
    '@media (min-width: 800px)': {
      height: 200,
      width: 200,
    },
    '@media (max-width: 800px)': {
      aspectRatio: 1 / 1,
      width: '100%',
      height: undefined,
    },
  },
  cardTerminated: {
    backgroundColor: 'rgba(0,0,0,0.1)',
  },
  cardDisabled: {
    color: 'grey',
  },
  picker: {
    color: 'black',
    backgroundColor: 'white',
    minHeight: 40,
  },
});

export { ids, styles };
